import { theme } from '@dot/design-system';
import { default as styled } from 'styled-components';

import { pulse } from '@/styles/helpers';

const SkeletonQr = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 20px;
    left: 20px;
    right: 20px;
    bottom: 20px;
    background-color: ${theme.colors.slateGray[30]};
    border-radius: 0.5rem;
    animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
`;

type Props = {
  qrCode: string | null;
};

export const QRCode = ({ qrCode }: Props) => {
  if (!qrCode) {
    return <SkeletonQr />;
  }

  return <img alt="QR Code" src={qrCode} />;
};
